import axiosAuth from "@/services/axiosAuth";
import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import { SAFETY_CHECKLIST_API } from "../apiRoutes";

interface UseGetSafetyChecklistItemListProps {
  checklistId: string;
  queryParams?: Omit<UseQueryOptions, "queryKey">;
}

const getSafetyChecklistItemList = async (checklistId: string) => {
  return await axiosAuth.get(`${SAFETY_CHECKLIST_API}/${checklistId}/items`);
};

const useGetSafetyChecklistItemList = ({
  checklistId,
  queryParams,
}: UseGetSafetyChecklistItemListProps): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["safety-checklist-item", checklistId],
    queryFn: () => getSafetyChecklistItemList(checklistId),
    select: (data: any) => data.data,
    refetchOnWindowFocus: false,
    ...queryParams,
  });
};

export default useGetSafetyChecklistItemList;
